module["exports"] = [
  "Librería",
  "Deportes",
  "Videojuegos",
  "Electrónica",
  "Moda",
  "Joyería",
  "Marroquinería",
  "Juguetería",
  "Mascotas",
  "Bebes",
  "Bricolaje",
  "Informática",
  "Salud",
  "Parafarmacia",
  "Papelería",
  "Cine",
  "Música",
  "Hogar",
  "Decoración"
]


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es/commerce/department.js
// module id = 2829
// module chunks = 1609